
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns5572ac1633762b7e20a66991d07f4b60en from './en.yaml'
            i18n.addResourceBundle('en', '5572ac1633762b7e20a66991d07f4b60', flattenObject(ns5572ac1633762b7e20a66991d07f4b60en), true, true);
        
        export default '5572ac1633762b7e20a66991d07f4b60';
    